angular.module('jrMyProfile', ['jrConfig', 'jrUtil']).controller('MyProfileCtrl', [
  '$scope',
  'MyProfileService',
  '$rootScope',
  'MyProfileConfig',
  function ($scope, MyProfileService, $rootScope, MyProfileConfig) {
    $scope.hasBeenSubmitted = false;
    $scope.forms = {};
    $scope.firstName = MyProfileConfig.firstname || '';
    $scope.lastName = MyProfileConfig.lastname || '';
    $scope.gdprJobMarketingAccepted = !MyProfileConfig.gdprJobMarketingAccepted;

    $scope.checkEmptyPasswordFields = function () {
      const profileForm = $scope.forms.profile;

      return (
        (profileForm.oldPassword &&
          !profileForm.oldPassword.$isEmpty(profileForm.oldPassword.$viewValue)) ||
        !profileForm.password.$isEmpty(profileForm.password.$viewValue) ||
        !profileForm.confirmPassword.$isEmpty(profileForm.confirmPassword.$viewValue)
      );
    };

    $scope.updateProfile = function (e) {
      $scope.hasBeenSubmitted = true;
      if ($scope.forms.profile.$invalid || $scope.forms.profile.$pristine) {
        return;
      }

      const myProfileData = {
        firstname: $scope.forms.profile.firstname.$viewValue
          ? $scope.forms.profile.firstname.$viewValue
          : '',
        lastname: $scope.forms.profile.lastname.$viewValue
          ? $scope.forms.profile.lastname.$viewValue
          : '',
        password: $scope.forms.profile.password.$viewValue
          ? $scope.forms.profile.password.$viewValue
          : '',
        'confirm-password': $scope.forms.profile.confirmPassword.$viewValue
          ? $scope.forms.profile.confirmPassword.$viewValue
          : '',
        'old-password':
          $scope.forms.profile.oldPassword && !!$scope.forms.profile.oldPassword.$viewValue
            ? $scope.forms.profile.oldPassword.$viewValue
            : '',
        gdprjobmarketingaccepted: !$scope.forms.profile.gdprjobmarketingaccepted.$viewValue,
      };

      $scope.loading = true;
      MyProfileService.updateProfile(myProfileData).then(updateSuccessful, updateFailed);

      e.preventDefault();
    };

    function updateSuccessful() {
      $scope.successUpdateProfile = true;
      $scope.loading = false;
      $rootScope.jobseekerFirstname = $scope.forms.profile.firstname.$viewValue;
      $rootScope.jobseekerLastname = $scope.forms.profile.lastname.$viewValue;

      if (
        $scope.forms.profile.firstname.$viewValue !== $scope.firstName ||
        $scope.forms.profile.lastname.$viewValue !== $scope.lastName
      ) {
        jtag('event', 'click_my_profile', {
          event_label: $scope.forms.profile.password.$viewValue
            ? 'change_profile_password'
            : 'change_profile',
        });
      } else {
        jtag('event', 'click_my_profile', {
          event_label: 'change_password',
        });
      }

      if (
        $scope.forms.profile.gdprjobmarketingaccepted.$viewValue !==
        MyProfileConfig.gdprJobMarketingAccepted
      ) {
        jtag('event', 'marketing_jobs_policy_client', {
          event_label: $scope.forms.profile.gdprjobmarketingaccepted.$viewValue
            ? 'optout'
            : 'optin',
        });
      }
    }

    function updateFailed(error) {
      $scope.hasBeenSubmitted = false;
      $scope.myProfileError = true;
      $scope.loading = false;
    }
  },
]);
